module.exports = __webpack_public_path__ + "static/media/microphone-alt-slash.caa1ce3d.svg";